export default "__VITE_ASSET__39beee9f__"